<template>
    <modal :allow-cancel="false" custom-class="max-w-md" @closed="$emit('closed')">
        <div v-if="!hasCharity">
            <div class="charity-box">
                <h2 v-text="$t('ABOUT_CONFORMATION')"/>
                <p  class="charityu" v-html="$t('FREDDIES_CHARITY_CONFORMATION')"/>
            </div>
            <div class="charity--price--image img-container">
                <img class="image" src="@/assets/images/decoration/dementia-adventure.png">
                <img class="image" src="@/assets/images/decoration/pennies-price.png">
            </div>
            <div>
                <p class="charityp" v-text="$t('FREDDIES_CHARITY_CANCEL')"></p>
            </div>
        </div>

        <div v-else>
            <div class="charity-box">
                <h2 v-text="$t('ABOUT_CANCEL')"/>
                <p class="charityu" v-html="$t('FREDDIES_CHARITY_UNCHECK')"/>
            </div>
            <div class="charity--price--image img-container">
                <img class="image" src="@/assets/images/decoration/dementia-adventure.png">
                <img class="image" src="@/assets/images/decoration/pennies-price.png">
            </div>
            <div>
                <p class="charityp" v-text="$t('FREDDIES_CHARITY_CANCEL')"></p>
            </div>
        </div>

        <submit-button
            slot="actions-prefix"
            color="border-white"
            @click="confirm"
            :processing="isProcessing"
            class="accept">{{ $t('CONFORM_MODAL_CONFIRM_CTA') }}</submit-button>
        <submit-button
            slot="actions-suffix"
            color="border-gray-400"
            @click="$emit('closed')"
            class="reject">{{ $t('CHARITY_MODAL_CANCEL_CTA') }}</submit-button>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/structure/Modal';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';

const subscriptionService = new SubscriptionService();

export default {
    name: 'CharityPriceModal',
    props: {
        subscriptionId: {
            type: Number,
            default: null,
            required: false,
        },
        showMoreInfoLink: {
            type: Boolean,
            default: true,
            required: false,
        },
    },
    data() {
        return {
            isProcessing: false,
        };
    },
    components: {
        Modal,
        SubmitButton,
    },
    methods: {
        confirm() {
            const price = this.hasCharity ? 0 : process.env.VUE_APP_CHARITY_PRICE;
            subscriptionService.charityPrice(this.subscriptionId, price).then(() => {
                this.$store.dispatch('subscription/fetchAllSubscriptions', true);
                this.loading = false;
                this.$emit('closed');
            }).catch(error => console.log(error.response.data));
        },
    },
    computed: {
        ...mapGetters({
            subscription: 'subscription/getActiveSubscription',
        }),
        hasCharity() {
            return this.subscription?.opt_in_charity_price;
        },
    },
};

</script>

<style lang="scss" scoped>
.check-box {
    width: 300px;
    background-color: #B2C89C;
    padding: 1rem;
    position: relative;
    margin-left: 1rem;
    margin-right: 1rem;
    border-radius: 8px;
}
.accept {
    width: 200px;
    margin: 10px 10px;
    background: #B2C89C;
    height: 55px;
    width: 340px;
    left: 0px;
    top: 65px;
    border-radius: 8px;
    padding: 15px, 24px, 15px, 24px;
}
.reject {
    width: 200px;
    margin: 10px 10px;
    background: #CECECE;
    height: 55px;
    width: 340px;
    left: 0px;
    top: 65px;
    border-radius: 8px;
    padding: 15px, 24px, 15px, 24px;

}
.btn {
    min-width: 150px;
}
.noClick {
    pointer-events: none;
}

.img-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.charityu {
    font-family: Gill Sans;
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: justified;

}
.charityp {
    font-family: Gill Sans;
    font-size: 15px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: justified;

}
</style>
